// extracted by mini-css-extract-plugin
export default {"font-renta":"AdminNewsEditor_font-renta__8ZqxR"};